import React from "react";
import { loadProgrammingLanguageIcon, programmingLanguageTagToImageFileObject } from "../scripts/FileLoader";
import './../styles/ProgrammingLanguagesBox.css';
function convertLanguageNameToIcon(programmingLanguageTag) {
    let programmingLanguageIconFileName = programmingLanguageTagToImageFileObject(programmingLanguageTag);
    return React.createElement("img", { style: { width: "100%", height: "100%" }, src: programmingLanguageIconFileName == null ? undefined : loadProgrammingLanguageIcon(programmingLanguageIconFileName), alt: programmingLanguageTag });
}
function ProgrammingLanguagesBox(props) {
    return React.createElement("div", { className: "programmingLanguagesBox" }, props.programmingLanguages.map((programmingLanguageTag, index) => React.createElement("div", { key: index, className: "singularLanguage" },
        " ",
        convertLanguageNameToIcon(programmingLanguageTag))));
}
export default ProgrammingLanguagesBox;
